@if (show$ | async) {
  <div class="pwa-banner" role="dialog" aria-label="Installer albR">
    <span class="ic"><img src="assets/icons/albr-mark.svg" alt="" /></span>
    <span class="txt">
      <b>Installer albR</b>
      <span>Accès direct depuis l'écran d'accueil, hors-ligne.</span>
    </span>
    <button class="btn" type="button" (click)="onInstall()">Installer</button>
    <button class="close" type="button" aria-label="Fermer" (click)="dismiss()">
      &times;
    </button>
  </div>
}
